import React, { useEffect, useState } from 'react';
import ChannelBanner from './ChannelBanner';
import VideoCard from './VideoCard';
import VideoModal from './VideoModal';

const YOUTUBE_API_KEY = 'AIzaSyBoVfMEHYpthjg80axZ7RYn-aLa2PFD7w4';
const CHANNEL_ID = 'UCBIXuTOBxbuq4jY2yWW9oOg'; // tannboss channel ID

export default function YouTubeGrid() {
  const [videos, setVideos] = useState([]);
  const [channel, setChannel] = useState<any>(null);
  const [search, setSearch] = useState('');
  const [selectedVideo, setSelectedVideo] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetch(`https://www.googleapis.com/youtube/v3/search?key=${YOUTUBE_API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=12`).then(res => res.json()),
      fetch(`https://www.googleapis.com/youtube/v3/channels?key=${YOUTUBE_API_KEY}&id=${CHANNEL_ID}&part=snippet,statistics`).then(res => res.json())
    ]).then(([videoData, channelData]) => {
      setVideos(videoData.items || []);
      setChannel(channelData.items?.[0] || null);
      setLoading(false);
    });
  }, []);

  const filteredVideos = videos.filter((video: any) =>
    video.snippet.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      {/* Channel Info Banner */}
      {channel && (
        <ChannelBanner channel={channel} />
      )}
      {/* Search Bar */}
      <div className="mb-8 flex justify-center">
        <input
          type="text"
          placeholder="Search videos..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="w-full max-w-md px-4 py-2 rounded-lg border border-[#23272e] bg-[#101014] text-white focus:outline-none focus:ring-2 focus:ring-[#14F195]"
        />
      </div>
      {/* Video Grid or Skeletons */}
      <div className="youtube-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.5rem' }}>
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="animate-pulse bg-[#23272e] rounded-xl h-[320px] w-full" />
            ))
          : filteredVideos.map((video: any) =>
              video.id.videoId ? (
                <VideoCard
                  key={video.id.videoId}
                  video={video}
                  onClick={() => setSelectedVideo(video)}
                />
              ) : null
            )}
      </div>
      {/* Video Modal/Lightbox */}
      {selectedVideo && (
        <VideoModal
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}
    </div>
  );
} 